import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import sv from './sv.json';
import en from './en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sv: { translation: sv },
      en: { translation: en }
    },
    // No hard-coded `lng`: read a language that the visitor actively selected.
    // LanguageSwitcher writes that choice; the detector must not create browser
    // storage before the visitor asks for the preference.
    supportedLngs: ['sv', 'en'],
    // Saknad nyckel i valt språk faller tillbaka till svenska så att en rå
    // i18next-nyckel aldrig visas för användaren.
    fallbackLng: 'sv',
    // Logga genuint saknade nycklar (saknas i alla språk) i utveckling så att
    // de fångas tidigt; i produktion tystas det och fallback gäller.
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (_lngs, _ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn(`[i18n] saknad översättningsnyckel: ${key}`);
      }
    },
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage'],
      caches: []
    }
  });

export default i18n;
